import React, { Component } from 'react';

class BarCodeReaderInput extends Component {

  state = {
    barCode: ""
  };

  appendBarCode = (c) => {
    switch (c) {
      case 8: // Backspace
          this.setState({ barCode: this.state.barCode.slice(0, -1) });
          break;
      default:
        this.setState({ barCode: this.state.barCode + String.fromCharCode(c) });
    }
  };

  handleKeyPress = (e) => {
    // Wait 100ms for the barcode reader to input all chars
    if(!this.state.barCode)
      setTimeout(function() {
        this.props.onBarCodeRead(this.state.barCode);
      }.bind(this), 100);
    this.appendBarCode(e.keyCode);
  };

  handleKeyDown = (e) => {
    // eslint-disable-next-line default-case
    switch (e.keyCode) {
      case 8: // Backspace
          e.preventDefault(); // Stops the backspace key from acting like the back button.
          this.appendBarCode(e.keyCode);
          break;
    }
  };

  componentDidMount() {
    window.addEventListener('keypress', this.handleKeyPress);
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.handleKeyPress);
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    return (<></>);
  }
}
export default BarCodeReaderInput;